import { Customization, css } from '@eduvision/toolkit';

export const PublicStatisticsBar: Customization['PublicStatisticsBar'] = {
	component: null,
};
